import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { Env, readFromEnv } from "@cinch-nx/environments";
import axios from "axios";
import { convertSearchFiltersToQueryParams } from "../../utils";
import { useSearchFilters } from "../use-search-filters";
import { useState } from "react";
export var httpClient = axios.create();
export function useSearchAlerts() {
    var params = useSearchFilters().params;
    var searchApiUrl = readFromEnv(Env.SearchServiceUrl);
    var queryParams = convertSearchFiltersToQueryParams(params);
    var ref = useState("initial"), fetchStatus = ref[0], setFetchStatus = ref[1];
    var ref1 = useState(null), error = ref1[0], setError = ref1[1];
    var url = "".concat(searchApiUrl, "/alert");
    var registerSearchAlert = function() {
        var _ref = _async_to_generator(function(email, frequency) {
            var error_;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!email || !frequency) {
                            return [
                                2
                            ];
                        }
                        setError(null);
                        setFetchStatus("pending");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            httpClient.post(url, {
                                sa_email_address: email,
                                sa_frequency: frequency,
                                sa_url: "?".concat(queryParams)
                            }, {
                                headers: {
                                    "x-search-api-consumer": "search-used-cars"
                                }
                            })
                        ];
                    case 2:
                        _state.sent();
                        setFetchStatus("success");
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error_ = _state.sent();
                        setError(error_);
                        setFetchStatus("error");
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function registerSearchAlert(email, frequency) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        registerSearchAlert: registerSearchAlert,
        fetchStatus: fetchStatus,
        error: error
    };
}
